import { AuthStore } from "../hooks/stores/AuthStore";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";

interface ProtectedRouteProps {
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

export default function ProtectedRoute({
  children,
  fallback = (
    <div className="min-h-screen flex items-center justify-center bg-slate-50">
      <div className="text-center">
        <div className="w-16 h-16 border-4 border-teal-500 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
        <p className="text-slate-600">Checking authentication...</p>
      </div>
    </div>
  ),
}: ProtectedRouteProps) {
  // Use _hasHydrated to know if we've finished reading from localStorage
  const isLoggedIn = AuthStore((state) => state.isLoggedIn);
  const hasHydrated = AuthStore((state) => state._hasHydrated); 
  
  const navigate = useNavigate();
  const { pathname } = useLocation();

  useEffect(() => {
    if (hasHydrated && !isLoggedIn) {
      // Check if user is already on a public page to avoid redirect loops
      const publicPages = ["/signin", "/"];
      if (!publicPages.includes(pathname)) {
        navigate("/signin", { replace: true });
      }
    }
  }, [hasHydrated, isLoggedIn, navigate, pathname]);

  // While waiting for localStorage, show the loader
  if (!hasHydrated) {
    return <>{fallback}</>;
  }

  // If loading is done, only show children if logged in
  return isLoggedIn ? <>{children}</> : null;
}